import React, { useState } from 'react';
import { Card, Button, Space, notification } from 'antd';
import { ShoppingOutlined, HistoryOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import CheckoutInterface from '../../../components/checkout/CheckoutInterface';
import TransactionHistory from '../../../components/checkout/TransactionHistory';
import { database, ref, push, set, update, get } from '../../Auth/db/firebase';
import { getCashierSession } from '../../../utils/cashierSession';

const CashierMode = () => {
  const { facilityId } = useParams();
  const [activeView, setActiveView] = useState('checkout');
  
  const [api, contextHolder] = notification.useNotification();

  const handleCheckout = async (transaction) => {
    try {
      // Get cashier info from session
  const cashierSession = getCashierSession(facilityId);
  // In admin mode: if cashier session exists, annotate with (admin); else mark as admin
  const cashierInfo = cashierSession ? `${cashierSession.name} (admin)` : 'admin';
      
      // Save transaction to daily transactions
      const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const transactionRef = ref(database, `transactions/${facilityId}/${today}`);
      const newTransactionRef = push(transactionRef);
      
      await set(newTransactionRef, {
        ...transaction,
        id: newTransactionRef.key,
        date: today,
        cashier: cashierInfo,
      });

      // Update inventory quantities (robust numeric handling)
      for (const item of transaction.items) {
        const itemRef = ref(database, `inventory/${facilityId}/items/${item.name}`);
        const itemSnapshot = await get(itemRef);
        if (itemSnapshot.exists()) {
          const currentData = itemSnapshot.val();
          const currQty = Number(currentData.quantity) || 0;
          const sold = Number(item.quantity) || 0;
          const newQuantity = Math.max(0, currQty - sold);
          await update(itemRef, {
            quantity: newQuantity,
            updatedAt: new Date().toISOString(),
          });
        }
      }

      api.success({
        message: 'Transaction Completed',
        description: 'Items sold and inventory updated successfully.',
      });
    } catch (error) {
      console.error('Checkout error:', error);
      throw new Error('Failed to complete transaction: ' + error.message);
    }
  };

  return (
    <div style={{ marginTop: 'var(--spacing-lg)' }}>
      {contextHolder}
      
      <Card
        title="Cashier Mode"
        extra={
          <Space>
            <Button
              type={activeView === 'checkout' ? 'primary' : 'default'}
              icon={<ShoppingOutlined />}
              onClick={() => setActiveView('checkout')}
            >
              Point of Sale
            </Button>
            <Button
              type={activeView === 'history' ? 'primary' : 'default'}
              icon={<HistoryOutlined />}
              onClick={() => setActiveView('history')}
            >
              Transaction History
            </Button>
          </Space>
        }
        bodyStyle={{ padding: 'var(--spacing-md)' }}
      >
        {activeView === 'checkout' ? (
          <CheckoutInterface
            facilityId={facilityId}
            onCheckout={handleCheckout}
            showTitle={false}
          />
        ) : (
          <TransactionHistory facilityId={facilityId} />
        )}
      </Card>
    </div>
  );
};

export default CashierMode;